import * as React from 'react';
import * as classNames from 'classnames';
import * as I18n from 'i18n-js';
import CoreLink from './core_link';
import { MParticleEvent } from '../elog/mparticle_types';

interface ITooltipPanelProps {
  text: JSX.Element | React.ReactNode | string;
  align?: 'top' | 'right' | 'bottom' | 'left';
  type?: 'icon' | 'underline' | 'plain';
  children?: React.ReactNode;
  preserveNewlines?: boolean;
  learnMoreLink?: {
    text?: string;
    href: string;
    clickEvent?: MParticleEvent;
  };
}

export default function TooltipPanel({
  text,
  align,
  type,
  children,
  preserveNewlines,
  learnMoreLink,
}: ITooltipPanelProps) {
  const classes = classNames(
    'tooltip-panel',
    { 'tooltip-panel--icon': type === 'icon' || !type }, // default to icon
    { 'tooltip-panel--underline': type === 'underline' },
    { 'tooltip-panel--plain': type === 'plain' },
    { 'tooltip-panel--align-top': align === 'top' || !align }, // default to top
    { 'tooltip-panel--align-right': align === 'right' },
    { 'tooltip-panel--align-bottom': align === 'bottom' },
    { 'tooltip-panel--align-left': align === 'left' },
    { 'tooltip-panel--preserve-newlines': preserveNewlines },
  );

  return (
    <span className={classes}>
      <span className="tooltip-panel__trigger">
        {children}
      </span>
      <span className="tooltip-panel__wrapper">
        <span className="tooltip-panel__content">
          {text}
          {learnMoreLink &&
            <CoreLink
              to={learnMoreLink.href}
              target="_blank"
              clickEvent={learnMoreLink.clickEvent}
              className="tooltip-panel__learn-more"
            >
              {learnMoreLink.text || I18n.t('commons.tooltipPanel.learnMore')}
            </CoreLink>
          }
        </span>
      </span>
    </span>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/tooltip_panel.tsx